<template>
  <div>
    <div></div>
    <div v-if="isLoading" class="loading">
      <img src="./img/cir.svg" />
    </div>
    <div v-else>
      <div @click="calcClick" v-if="!noEditText && isEditActive === false" class="empty">CALCULATE</div>
      <div
        @click="enableEditing"
        v-if="!editing && noEditText"
        class="textDisplay"
      >
        {{ noEditText}} mi
      </div>
        <!-- v-if="editing" -->

      <el-input-number :precision="2" :step="1" :max="9999.99"
        v-model="editableText"
        @blur="submitText"
        v-if="editing"
        maxlength="7"
        :controls="false"
        class="textInput"
        ref="inputRef">
      </el-input-number>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isEditActive: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      editing: false,
      editableText: "",
      noEditText: "",
    };
  },
  watch: {
    text(value) {
      console.log(value, "test");
      this.noEditText = value;
    },
    isEditable(value) {
      if (value) {
        this.enableEditing();
      }
    },
  },
  created() {
    this.noEditText = this.text;
    console.log(this.noEditText, "this.noEditText");
  },
  methods: {
    enableEditing() {
      this.editing = true;
      this.editableText = this.noEditText;
      this.$nextTick(() => {
        this.$refs.inputRef.focus();
        this.$refs.inputRef.setSelectionRange(
          this.editableText.length,
          this.editableText.length
        );
      });
    },
    submitText() {
      this.editing = false;
      this.$emit("input", this.editableText, this.index);
    },
    calcClick() {
      this.$emit("calcClick");
    },
  },
};
</script>

<style scoped lang='scss'>
.textDisplay {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  cursor: pointer;
  color: #000000;
}
/deep/ .el-input-number {
  width: auto !important;
}
/deep/ .el-input__inner {
  width: 80px !important;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  cursor: pointer;
  color: #000000;
  outline: none;
  text-align: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  height: 20px;
  line-height: 18px;
  color: #000000;
  border-radius: 2px;
  border: 1px solid #4066D4;
  background: rgba(64, 102, 212, 0.10);
  &:focus {
    border: 1px solid #4066d4;
    background: rgba(64, 102, 212, 0.1);
  }
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading img {
  animation: spin 1s linear infinite;
}

.empty {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  text-transform: uppercase;
  color: #4066d4;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
